/* eslint-disable react/button-has-type */
import React, { forwardRef, HTMLProps } from 'react';
import clsx from 'clsx';
import './style.scss';

/* eslint-disable-next-line */
export interface IButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    outlined?: boolean;
    icon?: JSX.Element;
    text?: string;
    rounded?: boolean;
    variant?: 'blue' | 'black' | 'white' | 'snow-white' | 'icon';
}

export const Button = forwardRef<HTMLButtonElement, IButtonProps>((props, ref) => {
    const {
        className,
        type = 'button',
        variant = 'blue',
        icon,
        outlined,
        text,
        rounded = false,
        ...otherProps
    } = props;

    const renderIcon = () => (icon ? <span className='icon'>{icon}</span> : null);
    const renderText = () => (text ? <span className='text'>{text}</span> : null);

    return (
        <button
            type={type}
            ref={ref}
            className={clsx('oms-button', className, {
                'outlined': outlined,
                'no-icon': !icon,
                'no-text': !text,
                'rounded': rounded,
                'variant-blue': variant === 'blue',
                'variant-black': variant === 'black',
                'variant-white': variant === 'white',
                'variant-snow-white': variant === 'snow-white',
                'variant-icon': variant === 'icon'
            })}
            {...otherProps}
        >
            { renderIcon() }
            { renderText() }
        </button>
    );
});
